type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

export const EDITOR_HEADERS: Header[] = [

  {
    key: "patientName",
    label: "Patient Name",
    style: { width: "240px" },
    sortable: true,
  },
  {
    key: "qmeDoctorName",
    label: "Doctor",
    style: { width: "130px" },
    sortable: true,
  },
    {
    key: "caseOrExamType",
    label: "Case / Exam Type",
    style: { width: "100px" },
    sortable: true,
  },
    {
    key: "appointmentDateTime",
    label: "Appointment Date & Time",
    style: { width: "220px" },
    sortable: true,
  },
  {
    key: "locationofAppointment",
    label: "Location",
    style: { width: "250px" },
    sortable: true,
  },
   {
    key: "dictationId",
    label: "Dictations",
    style: { width: "50px" },
    isNumeric: true,
  },
  {
    key: "editorDueDateDesc",
    label: "Due Date",
    style: { width: "100px" },
    sortable: true,
  },
  {
    key: "appointmentStatus",
    label: "Appointment Status",
    style: { width: "200px" },
    sortable: true,
  },
   {
    key: "reportStatus",
    label: "Report Status",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "transcriptionFileName",
    label: "Transcription",
    style: { width: "120px", minWidth: "150px" },
    sortable: true,
  }, 
 
   {
    key: "assignedTo",
    label: "Editor Assigned",
    style: { width: "200px" },
    sortable: true,
  }, 

  {
    key: "dwcStatus",
    label: "DWC Status",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "caseId",
    label: "Case ID ",
    style: { width: "150px" },
    sortable: true,
  }, 
];
export const EXPORT_EDITOR_HEADERS: Header[] = [
  {
    key: "caseId",
    label: "Case ID ",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "patientName",
    label: "Patient Name",
    style: { width: "140px" },
    sortable: true,
  },
  {
    key: "qmeDoctorName",
    label: "Doctor",
    style: { width: "200px" },
    sortable: true,
  },
  {
    key: "caseOrExamType",
    label: "Case / Exam Type",
    style: { width: "100px" },
    sortable: true,
  },
  {
    key: "format_dueDate",
    label: "Due Date",
    style: { width: "80px" },
    sortable: true,
  },
  {
    key: "reportStatus",
    label: "Report Status",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "appointmentDateTime",
    label: "Appointment Date & Time",
    style: { width: "200px" },
    sortable: true,
  },
  {
    key: "appointmentStatus",
    label: "Appointment Status",
    style: { width: "200px" },
    sortable: true,
  },

  {
    key: "dwcStatus",
    label: "DWC Status",
    style: { width: "150px" },
    sortable: true,
  },

  {
    key: "assignedTo",
    label: "Assigned To",
    style: { width: "200px" },
    sortable: true,
  },
];

export const DICTATIONS_FILE_HEADERS: Header[] = [
  {
    key: "fileName",
    label: "Sr.No",
    sortable: false,
    style: { width: "30%" },
  },
  {
    key: "fileNameNew",
    label: "File Name",
    sortable: false,
    style: { width: "32%" },
  },
  {
    key: "download",
    label: "Action",
    style: { width: "10%" },
  },
];

export const DICTATIONS_VERSION_HEADER: Header[] = [
  { label: "Sr.No", key: "revisionNoDesc", style: { width: "25%" } },
  { label: "File Name", key: "fileNameNew" },
  { label: "Action", key: "download" },
];

export const PICKLIST_GROUP_NAME = {
  DWCExtensionStatus: "DWCExtensionStatus",
  DWCExtensionRequestedDays: "DWCExtensionRequestedDays",
  DWCExtension_30daysReasons: "DWCExtension_30daysReasons",
  DWCExtension_15daysReasons: "DWCExtension_15daysReasons",
};

export const LOG_HEADERS: Header[] = [
  { key: "newStatusName", label: "Stage" },
  { key: "who", label: "Who" },
  { key: "userRoleName", label: "Role" },
  { key: "when", label: "When" },
  { key: "newcomments", label: "Comment" },
];

export const EDITOR_LOGS_HEADERS: Header[] = [
  {
    key: "doctorQMEStatusName",
    label: "Report Status",
  },
  {
    key: "editorAssignedUserName",
    label: "Who",
  },
  {
    key: "createdByUserRole",
    label: "Role",
  },
  {
    key: "createdDateNew",
    label: "When",
  },
  {
    key: "editorComments",
    label: "Comments",
  },
];

export const DWC_LOG_HEADERS: Header[] = [
  { key: "status", label: "DWC Status" },
  { key: "who", label: "Who" },
  { key: "role", label: "Role" },
  { key: "when", label: "When" },
];